/**
 * The valuer's optional free-text note, left at upload time (see screens/NewUpload.tsx).
 * Shown ABOVE the report summary so the reviewer sees anything the valuer flagged
 * before anything else - also included at the top of the report-ready email (see
 * worker/src/reportReady/template.ts).
 */
import { Tile } from '../ui';

interface ValuerNotesSectionProps {
  notes: string | null;
}

export function ValuerNotesSection({ notes }: ValuerNotesSectionProps) {
  if (!notes || !notes.trim()) return null;

  return (
    <section className="section">
      <div className="section__head">
        <h2 className="section__title">Note from the valuer</h2>
      </div>
      <Tile className="valuer-note">
        <p className="valuer-note__text">{notes}</p>
      </Tile>
    </section>
  );
}
